// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__3IyZA","img":"Image_img__Qdx_6","skeleton":"Image_skeleton__3ut2c"};